import ReactSelectCreatable from 'react-select/creatable';
import classNames from 'classnames';

import { InputLabel } from '@ui/InputLabel';
import { FormError } from '@ui/FormError';

import { SelectCreatableProps, GroupBase } from '../../types';
import { getDefaultProps } from '../../utils';

import s from './SelectCreatable.sss';

export function SelectCreatable<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>,
>({
  required,
  ...props
}: SelectCreatableProps<Option, IsMulti, Group>) {
  const {
    className,
    label,
    error,
    helpText,
    inputClassName,
  } = props;

  const defaultProps = getDefaultProps(props);

  return (
    <div
      className={classNames(
        s.root,
        className,
      )}
    >
      {label
        && (
        <InputLabel
          className={s.label}
          required={required}
        >
          {label}
        </InputLabel>
        )}

      <ReactSelectCreatable
        {...defaultProps}
        {...props}
        className={classNames(s.input, inputClassName)}
      />

      {helpText && <div className={s.helpText}>{helpText}</div>}
      {error && (
        Array.isArray(error)
          ? error.map((e, i) => <FormError key={i}>{e}</FormError>)
          : <FormError>{error}</FormError>
      )}
    </div>
  );
}
